import Vue from 'vue'
import Vuex from 'vuex'
import { Evenement } from './evenement/index'
import { RenseignementProfessionnel } from './renseignementProfessionnel/index'
import { TableauDesMembres } from './tableauDesMembres/index'
import { Catalogue } from './catalogue/index'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Evenement,
        RenseignementProfessionnel,
        TableauDesMembres,
        Catalogue
    }
})
